export const actionTypes = {
  DOWNLOAD_SCENE: 'SharePage/DOWNLOAD_SCENE',
  DOWNLOAD_STATUS: 'SharePage/DOWNLOAD_STATUS',
  PROGRESS_VALUE: 'SharePage/PROGRESS_VALUE',
  CRRUENT_SLIDE_INDEX: 'SharePage/CRRUENT_SLIDE_INDEX',
  PAGE_CONFIG_DATA: 'SharePage/PAGE_CONFIG_DATA',
};

export const loadDownloadScene = (payload: String) => ({
  type: actionTypes.DOWNLOAD_SCENE,
  payload,
});
export const loadDownLoadStatus = (payload: string) => ({
  type: actionTypes.DOWNLOAD_STATUS,
  payload,
});
export const loadProgressValue = (payload: String) => ({
  type: actionTypes.PROGRESS_VALUE,
  payload,
});
export const loadCurrentSlideIndex = (payload: String) => ({
  type: actionTypes.CRRUENT_SLIDE_INDEX,
  payload,
});
export const setPageConfigData = (payload: Object) => ({
  type: actionTypes.PAGE_CONFIG_DATA,
  payload,
});
